const getCompanyLogoWidth = (rootState) =>
  rootState.ws.integration.settings.branding &&
  rootState.ws.integration.settings.branding.companyLogoWidth;

export default getCompanyLogoWidth;
